import { render, staticRenderFns } from "./page-element-user-my-account.vue?vue&type=template&id=920e8370"
import script from "./page-element-user-my-account.vue?vue&type=script&lang=js"
export * from "./page-element-user-my-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports